import React from 'react';
import { NavLink } from 'react-router-dom';
import { supabase } from '../../utils/supabaseClient';

const TABS = [
    { to: '/admin', label: 'Applications', end: true },
    { to: '/admin/posts', label: 'Post plan' },
    { to: '/admin/studio', label: 'Studio' },
    { to: '/admin/payments', label: 'Payment links' },
    { to: '/admin/contacts', label: 'Archived contacts' },
    { to: '/admin/crew', label: 'Sound crew', crew: true },
];

/**
 * Tabs across the top of every admin page, plus who is signed in. A sound lead who is not an
 * admin (staff passed by the crew page) only gets the crew tab.
 */
const AdminNav = ({ session, staff }) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px', marginBottom: '28px', borderBottom: '1px solid #222', paddingBottom: '14px' }}>
        <nav style={{ display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
            {TABS.filter((t) => t.crew || !staff || staff.is_admin).map((t) => (
                <NavLink key={t.to} to={t.to} end={t.end} style={({ isActive }) => ({
                    padding: '8px 16px', fontFamily: 'var(--font-heading)', letterSpacing: '2px', textTransform: 'uppercase', fontSize: '13px',
                    background: isActive ? '#c89b3c' : 'transparent', color: isActive ? '#0a0a0a' : '#aaa', border: `1px solid ${isActive ? '#c89b3c' : '#333'}`,
                })}>{t.label}</NavLink>
            ))}
        </nav>
        <div style={{ color: '#777', fontSize: '13px' }}>
            {session.user.email} · <button type="button" onClick={() => supabase.auth.signOut()} style={{ background: 'none', border: 'none', color: '#c89b3c', cursor: 'pointer', padding: 0, font: 'inherit' }}>Sign out</button>
        </div>
    </div>
);

export default AdminNav;
